import { FSFundMetrics } from "src/app/domain/fund-strategy/pojo/fund-strategy-export-classes";
import { getHeadersForDisplayForCommitmentAllocation, getHeadersForLogicForCommitmentAllocation } from "./headers";
import { formats, getCell, withCellStyles } from "../../../utils";
import { Rows } from "../../../interfaces";
import { boldBottomBorderThickTopThinRight, rightBoldGrayForHeaders } from "src/app/util/excelStyles";
import { emptyArrayForSpace, multipleGroupGrandTotalRowIndex, onlyOneGroup, singleGroupTotalIndex } from "./mapping";

const getNewMappingForTotalCommitment = (metric: FSFundMetrics): object[] => {
  const body = {
    '': 'Total commitment',
    'Commitment allocation': getCell({
      v: metric.totalCommitment,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
  };
  return [body];
};


const getNewMappingForExpectedExpenses = (metric: FSFundMetrics): object[] => {
  const body = {
    '': 'Expected expenses',
    'Commitment allocation': getCell({
      f: `B3*D4`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    empty: null,
    'empty(0)': getCell({
      v: metric.expectedExpensesPcnt / 100,
      z: formats.percents,
      t: 'n',
    }),
  };
  return [body];
};

const getNewMappingForInvestment = (): object[] => {
  const body = {
    '': 'Investment',
    'Commitment allocation': getCell({
      f: onlyOneGroup ? `H${singleGroupTotalIndex}` : `H${multipleGroupGrandTotalRowIndex}`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
  };
  return [body];
};

const getNewMappingUnallocatedCommitment = (): object[] => {
  const body = {
    '': 'Unallocated commitment/(Over the fund size)',
    'Commitment allocation': getCell({
      f: `B3-B4-B5`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
  };
  return [body];
};


const getRowForTotalCommitment = (metric: FSFundMetrics): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = getNewMappingForTotalCommitment(metric);
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of getHeadersForLogicForCommitmentAllocation()) {
      row.push(withCellStyles(mapped[header], null));
    }
    rows.push(row);
  }
  return rows;
};

const getRowForExpectExpenses = (metric: FSFundMetrics): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = getNewMappingForExpectedExpenses(metric);
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of getHeadersForLogicForCommitmentAllocation()) {
      row.push(withCellStyles(mapped[header], null));
    }
    rows.push(row);
  }
  return rows;
};

const getRowForInvestment = (): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = getNewMappingForInvestment();
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of getHeadersForLogicForCommitmentAllocation()) {
      row.push(withCellStyles(mapped[header], null));
    }
    rows.push(row);
  }
  return rows;
};

const getRowForUnallocatedCommitment = (): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = getNewMappingUnallocatedCommitment();
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of getHeadersForLogicForCommitmentAllocation()) {
      row.push(withCellStyles(mapped[header], boldBottomBorderThickTopThinRight));
    }
    rows.push(row);
  }
  return rows;
};

export const getCommitmentAllocation = (newData: Rows, metric: FSFundMetrics): Rows => {
  const designedHeaderRow = [];
  getHeadersForDisplayForCommitmentAllocation().forEach((header) => designedHeaderRow.push(withCellStyles(header, rightBoldGrayForHeaders)));
  newData.push(designedHeaderRow);
  const totalCommitmentRow = getRowForTotalCommitment(metric);
  newData.push(...totalCommitmentRow);
  const expectedExpensesRow = getRowForExpectExpenses(metric);
  newData.push(...expectedExpensesRow);
  const investmentRow = getRowForInvestment();
  newData.push(...investmentRow);
  const unallocatedRow = getRowForUnallocatedCommitment();
  newData.push(...unallocatedRow);
  newData.push(emptyArrayForSpace);
  newData.push(emptyArrayForSpace);
  return newData;
};
